export const PRODUCT_CATEGORY_SELECTED = "PRODUCT_CATEGORY_SELECTED"
export const RESET_PRODUCTS_STEPPER = "RESET_PRODUCTS_STEPPER"